import {
Button,
HStack,
Image,
LinkOverlay,
SimpleGrid,
} from "@chakra-ui/react";
import { Error404ImageUrl, seoThumbnailUrl } from "../Components/imagesLink";

import { ArrowBackIcon } from "@chakra-ui/icons";
import { Seo } from "../Components/Seo";

const PageNotFound = () => {
  return (
    <>
      <Seo
        title="Page Not Found - WpCalendar | Whatsapp chat to calendar events!"
        description="Effortlessly convert WhatsApp chat events to calendar events with our privacy-conscious tool. Keep track of important dates without compromising your data privacy."
        type="website"
        name="Soham_UltraHopeful"
        url="https://wpcalendar.vercel.app/help"
        imageUrl={seoThumbnailUrl}
      />
      <SimpleGrid SimpleGrid columns={1} spacing={[10, 8, 5]} p={5} >
        <Image
          width={"35em"}
          src={Error404ImageUrl}
          alt={"Page not found illustration"}
          m={"0 auto"}
        ></Image>
        <HStack justifyContent={"center"}>
            
        <Button
                as={LinkOverlay}
                href={"/"}
                size={"lg"}
                leftIcon={<ArrowBackIcon />}
                px={6}
                colorScheme={"blue"}
                className={"leftIconAnimate"}
              > Go Back To Home</Button>
        </HStack>
      </SimpleGrid>
    </>
  );
};

export default PageNotFound;